import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import {  useState } from "react";
import { useDispatch } from "react-redux";
import { toggleSidebar } from "../../Redux/Layout/layoutSlice";
import { Link } from "react-router-dom";
import LanguageSwitcher from "components/LangSwitch";
import { useTranslation } from "react-i18next";

export default function PrimarySearchAppBar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
const {t} = useTranslation();
 

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch();

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      sx={{
        top: "40px",
      }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem onClick={handleMenuClose}>Profile</MenuItem> */}
      <MenuItem
        onClick={handleMenuClose}
        sx={{ py: 1, textAlign: "center", mb: 1 }}
      >
        <Link to={"/profile"}>حساب کاربری</Link>
      </MenuItem>
      <MenuItem
        onClick={handleMenuClose}
        sx={{ py: 1, textAlign: "center", color: "red" }}
      >
        <Link to={"/admin/logOut"}>خروج از حساب</Link>
      </MenuItem>
    </Menu>
  );

  return (
    <Box>
      <AppBar sx={{ backgroundColor: "#512C63" , display:"flex", justifyContent:"space-between" , flexDirection:"row" , alignItems:"center" }} position="sticky">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={() => dispatch(toggleSidebar())}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            noWrap
            component="div"
            sx={{ display: { xs: "none", sm: "block" } }}
          >
            {t("Header.Student")}
          </Typography>

          <Box sx={{ flexGrow: 1 }} />
        
        </Toolbar>
        <Box px={4}>
          <LanguageSwitcher />
        </Box>
      </AppBar>
      {renderMenu}
    </Box>
  );
}
